import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter, type RouteObject } from 'react-router';
import { paths } from '@shared/configs/paths';

// Lazy so the mock route never pulls in the live socket bus (and vice versa):
// `home` transitively imports `@features/sensor-bus`, which opens the socket.
const HomePage = lazy(() => import('./home').then((m) => ({ default: m.HomePage })));
const MockPage = lazy(() => import('./mock').then((m) => ({ default: m.MockPage })));

const lazyEl = (node: ReactNode): ReactNode => <Suspense fallback={null}>{node}</Suspense>;

const ROUTES: RouteObject[] = [
  {
    path: paths.home,
    element: lazyEl(<HomePage />),
  },
  {
    path: paths.mock,
    element: lazyEl(<MockPage />),
  },
];

export const router = createBrowserRouter(ROUTES);
